import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  StaffPayScale,
  StaffPayScaleFilters
} from '../../lib/types/models/staff-pay-scale/staff-pay-cale'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getStaffPayScales(input?: PaginationRequest<StaffPayScaleFilters>) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.staffPayScales.getAll.url, null),
        input
      )
    )
    .get<PaginationResponse<StaffPayScale>>()
}
